import { StaticImage } from "gatsby-plugin-image"

import React from "react"
import SwiperCore, { Navigation, Pagination, EffectFlip } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper-bundle.css"

SwiperCore.use([Navigation, Pagination, EffectFlip])

const ProductCarousel = ({ images }) => {
  return (
    <Swiper
      wrapperTag="ul"
      id="main"
      navigation
      pagination
      effect={"flip"}
      className="product-page"
    >
      {images.map((image, i) => (
        <SwiperSlide
          className="hero-swiper text-center"
          tag="li"
          style={{ listStyle: "none" }}
          key={i}
        >
          <img
            src={image?.asset?.url}
            alt={image?.asset?.url}
            className="img-fluid product-image"
          />
        </SwiperSlide>
      ))}

      {/* <SwiperSlide
        className="hero-swiper"
        tag="li"
        style={{ listStyle: "none" }}
      >
        <StaticImage
          placeholder="blurred"
          className="img-fluid mb-5 product-image"
          src="../../images/lux-band.png"
          alt="fluxproducts"
        />
      </SwiperSlide>
      <SwiperSlide
        className="hero-swiper"
        tag="li"
        style={{ listStyle: "none" }}
      >
        <StaticImage
          placeholder="blurred"
          className="img-fluid mb-5 product-image"
          src="../../images/dark-lux-band.png"
          alt="fluxproducts"
        />
      </SwiperSlide> */}
    </Swiper>
  )
}

export default ProductCarousel
